<template>
    <img :src="url('img/doorax-logo.svg')" alt="Doorax - Cilindersloten en deurbeslag" width="160" height="auto" loading="eager" fetchpriority="high">
</template>